// extracted by mini-css-extract-plugin
export var close = "bT_F";
export var container = "bT_b";
export var heading = "bT_G";
export var linkContainer = "bT_bt";
export var logoIcon = "bT_bs";
export var section = "bT_d";
export var show = "bT_L";
export var title = "bT_h";
export var value = "bT_bv";